module.exports = __webpack_public_path__ + "assets/bulldozer.svg?f1b927e6f8fb47263b748c05057f6d04";